/* RSC Health  -  product / panel page behavior (Phase 3).
   Plain ES5 IIFE, guarded on [data-rsc-product]. Only what this page needs beyond the
   ZIP-check snippet's own inline script and Dawn's product-form.js:
     1. mobile sticky bar "Add" proxies the main Add-to-Cart button (Dawn AJAX preserved)
     2. biomarker "+N more" reveal on included-test cards
     3. related-panel "+ Add to my order" one-tap AJAX add (same blood draw cross-sell)
   The FAQ accordion is native <details>/<summary>  -  no JS. The ZIP-check logic lives in
   the snippet and is NOT duplicated here. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rsc-product]');
  if (!root) return;
  var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add';

  /* --- 1. Add-to-Cart → AJAX add → cart page (RSC linear flow: product → cart →
     Patient & Lab → checkout).
     We own the submit instead of Dawn's <product-form>: on this store the Section
     Rendering API returns null for the cart-notification sections, so Dawn's notification
     path throws after the (successful) add and the click looks dead. We intercept in the
     CAPTURE phase on the container  -  this fires before <product-form>'s own submit
     handler on the descendant form, and stopImmediatePropagation prevents it from running
      -  then AJAX-add and go to /cart. The redirect is RELATIVE so it stays on the current
     host + previewed theme (a native cross-domain redirect to the primary domain would
     drop the theme preview cookie and land on the live theme). */
  root.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.getAttribute('data-type') !== 'add-to-cart-form') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var idInput = f.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var btn = f.querySelector('[type="submit"]');
    var lbl = btn && btn.querySelector('span');
    var orig = lbl && lbl.textContent;
    if (btn) btn.disabled = true;
    if (lbl) lbl.textContent = 'Adding…';
    var body = new FormData();
    body.append('id', idInput.value);
    var qty = f.querySelector('[name="quantity"]');
    body.append('quantity', (qty && qty.value) || 1);
    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/javascript' }, body: body })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () { window.location.assign('/cart'); })
      .catch(function () {
        if (btn) btn.disabled = false;
        if (lbl) lbl.textContent = orig || 'Add to cart';
      });
  }, true);

  /* --- mobile bar Add proxies the main Add-to-Cart button --- */
  var mobAdd = root.querySelector('[data-rsc-mob-add]');
  var mainSubmit = root.querySelector('[data-rsc-main-submit]');
  if (mobAdd && mainSubmit) {
    mobAdd.addEventListener('click', function () {
      if (mainSubmit.disabled) return;
      mainSubmit.click();
    });
  }

  /* --- 2. biomarker "+N more" reveal --- */
  var moreBtns = root.querySelectorAll('[data-bio-more]');
  Array.prototype.forEach.call(moreBtns, function (btn) {
    btn.addEventListener('click', function () {
      var chips = btn.parentNode.querySelectorAll('.bio-extra');
      Array.prototype.forEach.call(chips, function (c) { c.hidden = false; });
      btn.parentNode.removeChild(btn);
    });
  });

  /* --- 3. related-panel one-tap add --- handled globally by rsc-atc.js: the related
     "+ Add" buttons carry [data-rel-add][data-variant-id] and add → /cart with a visible
     error on failure, matching every other add-to-cart button on the site. --- */
})();
